// extracted by mini-css-extract-plugin
export default {"title":"_3yVaM8hD8NiYiAXJrF8uXS","noTopPadding":"_3lEtj5Luk3UCxR-fyt129h","noVerticalPadding":"_1NaTpS0Ksjb7Z-EEcBSsjl"};